import React, { useEffect } from 'react';
import { fetchSymbolIfNeeded } from '../../actions/symbols';
import useActions from '../../utils/hooks/useActions';
import useSymbolMetadata from '../../utils/hooks/useSymbolMetadata';
import MemoContainer from '../symbolOverview/MemoContainer';
import NewsSidebarContainer from './NewsSidebarContainer';
import './SymbolDetails.scss';
import SymbolInfoHeader from './SymbolInfoHeader';
import SymbolQuoteCard from './SymbolQuoteCard';
import { TabComponent } from './TabComponent';

/**
 * SymbolDetails - Desktop symbol details with Sometaro-style header
 *
 * @returns {React.Component} Symbol Details view
 */
const SymbolDetails = ({ match }) => {
  const symbol = match.params.symbol;
  const [getSymbol] = useActions([fetchSymbolIfNeeded], []);
  const symbolMetadata = useSymbolMetadata(symbol);

  useEffect(() => {
    getSymbol(symbol);
  }, [getSymbol, symbol]);

  const [mode, setMode] = React.useState('summary');

  return (
    <div className="symbol-details">
      <SymbolInfoHeader symbolMetadata={symbolMetadata} />

      <div className="symbol-content">
        <div className="side-panel">
          <div className="quote-card-section">
            <SymbolQuoteCard symbol={symbol} />
          </div>
          <div className="memo-section">
            <MemoContainer symbol={symbol} />
          </div>
          <div className="news-section">
            {(mode === 'summary' ||
              mode === 'indicators' ||
              mode === 'historical') && (
              <NewsSidebarContainer symbol={symbol} newsAmount={10} />
            )}
          </div>
        </div>

        <div className="additional-details">
          <TabComponent mode={mode} setMode={setMode} symbol={symbol} />
        </div>
      </div>
    </div>
  );
};

export default SymbolDetails;
